export const isEmpty = (value) => !value || value?.toString().trim() === '';

export const exceedsLimit = (value, limit) =>
  typeof value === 'string' && value?.toString().trim()?.length > limit;
